import axios from 'axios';


const service = axios.create({
  baseURL: 'http://10.15.232.65',
  timeout: 1000,
});

service.interceptors.response.use(
  response => response.data,
);

export function getAddressBooks() {
  return service({
    url: '/jaberphp/index.php/admin/admin/index',
    method: 'post',
  });
}
